import { ActionButton } from "@/components/shared/action-buttons"
import { SheetPage, SheetPageTrigger } from "@/components/ui/sheet-page"
import { Users } from "lucide-react"
import { useTranslation } from "react-i18next"

// Each sheet opens the invitation form in the user's own workspace; its href
// comes from the page's capabilities, built by the server from that workspace.
export function SchoolReliefListingSheet({
  href,
  relief_invitable_token,
  listing_profile_uuid,
}: {
  href: string
  relief_invitable_token: string
  listing_profile_uuid: string
}) {
  const { t } = useTranslation("search")

  return (
    <SheetPage
      href={href}
      data={{ listing_profile_uuid, relief_invitable_token }}
    >
      <SheetPageTrigger asChild>
        <ActionButton Icon={Users} variant="default">
          {t("show.teacher.invite")}
        </ActionButton>
      </SheetPageTrigger>
    </SheetPage>
  )
}

export function EducatorReliefListingSheet({
  href,
  relief_invitable_token,
  listing_profile_uuid,
}: {
  href: string
  relief_invitable_token: string
  listing_profile_uuid: string
}) {
  const { t } = useTranslation("search")

  return (
    <SheetPage
      href={href}
      data={{ listing_profile_uuid, relief_invitable_token }}
    >
      <SheetPageTrigger asChild>
        <ActionButton Icon={Users} variant="default">
          {t("show.teacher.invite_to_relief_listing")}
        </ActionButton>
      </SheetPageTrigger>
    </SheetPage>
  )
}
